/*
 * @Author: 李朋飞
 * @Date: 2021-07-15 19:02:49
 * @LastEditTime: 2021-09-06 10:33:54
 * @Description: 用来设置state内的数据
 * 直接使用：
 * import { mapMutations } from 'vuex';
 * methods: {
 *    ...mapMutations({ // 取出定义再vuex内的方法 ,相当于直接再methods内定义了一个setLogo方法；
          setLogo: 'SET_LOGO'
        }),
      this.setLogo(product); product对应这里接收的参数
 * }
  
    通过 actions使用， 在actions内通过调用mutation-types内的方法来使用
 */

import storage from '@/service/storage';
import * as types from './mutation-types';

const mutations = {
  [types.GET_MEN_LIST](state, menuList) {
    state.menuList = menuList;
  },
  [types.ROUTER_LIST_NEW](state, routerListNew) {
    state.routerListNew = routerListNew;
  },
  [types.MY_INFO](state, myInfo) {
    state.myInfo = myInfo;
  },
  [types.CHAT_UNREAD](state, unread) {
    state.chat_unread = unread;
  },
  [types.USER_ID](state, userId) {
    state.userId = userId;
  },
  [types.CONVERSATION_LIST](state, conversationList) {
    conversationList.map(item => {
      item.isCheck = false;
    });
    state.conversationList = conversationList;
  },
  [types.HISTORY_MESSAGE](state, historyMessage) {
    if (Array.isArray(historyMessage)) {
      state.historyMessage = [...historyMessage];
    }
  },
  [types.UPDATE_CHAT_HISTORY](state, payload) {
    state.newMessages.push(payload);
    // 过滤掉群通知消息
    state.newMessages = state.newMessages.filter((item) => item.type != 'notification');
  },
  [types.UPDATE_CHAT_HISTORY_FILTER](state, idClient) {
    console.log(typeof payload != Object);
    if (typeof payload != Object) {
      state.newMessages = state.newMessages.filter(
        (item) => item.idClient != idClient
      );
    }
  },
  [types.USER_IS_TYPING](state, userIsTyping) {
    state.userIsTyping = userIsTyping
  },
  [types.SELECT_CONVERSATION_LIST](state, val) {
    if(storage.getItem('conversationListCopy')) {
      let originalConversationList = JSON.parse(JSON.stringify(storage.getItem('conversationListCopy')));
      state.conversationList = originalConversationList.filter((item) =>
        item.nick && item.nick.includes(val)
      );
      if (!val) {
        let conversationListCopy = storage.getItem('conversationListCopy');
        // 置顶数据
        let isTop = conversationListCopy.filter((item) => item.isTop);
        // 非置顶数据
        let noTop = conversationListCopy.filter((item) => !item.isTop);
        const newsConversationList = [...isTop,...noTop];
        state.conversationList = newsConversationList;
      }
    }
  },
  [types.MSG_RECEIPTS](state, msgReceipts) {
    state.msgReceipts = msgReceipts
  },
  [types.UPDATE_CONVERSATION_LIST](state, id) {
    state.conversationList = state.conversationList.filter(item => item.id != id);
    state.deleteUserId = id;
    JSON.stringify(storage.setItem('conversationListCopy', state.conversationList));
  },
  [types.SET_MENU_LIST](state, key) {
    state.menuList.forEach(item => {
      if (item.children && item.children.length) {
        item.children.forEach(childItem => {
          if(childItem.children && childItem.children.length) {
            childItem.children.map(childItems => {
            if (childItems.path == key) {
                item.path = childItems.path;
                childItem.path = childItems.path;
              }
            })
          }
          if(item.id == 562 && item.name == '供应商' && key == '/ExamList') {
            item.path = key;
          }
          if(item.id == 563 && item.name == 'SaaS中心' && key == '/saasEnterprise') {
            item.path = key;
          }
          if(item.id == 564 && item.name == '平台运营' && (key == '/ContentList' || key == '/QuestionList' || key == '/NewsList' || key == '/report' || key == '/presentation')) {
            item.path = key;
          }
        });
      }
    });
    console.log(state.menuList,'state.menuList');
  },
  [types.CHAT_NOTION_MSG](state, msg) {
    state.chatNotionMsg = msg;
  },
  [types.UPDATE_DELETE_USERID](state) {
    state.deleteUserId = null;
  },
  [types.CHECK_CONVERSATION_LIST](state, val) {
    state.conversationList.map(item => {
      item.isCheck = val;
    })
  },
};


export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js